import { useMemo } from 'react';
import { Checkbox } from 'antd';
import { useThrottleEffect } from 'ahooks';
import type { CheckboxChangeEvent } from 'antd/es/checkbox';
import css from './index.module.scss';
import styledModal from '@/components/AppreciationDay/Nav/index.module.scss';
import { euLocaleList } from '@/constants/appreciationDay';
import EditorImg from 'lowcode/components/EditorImg';
import { useGlobal } from '@/utils/useGlobal';
import EfModal from '@/components/UI/Modal';
import Emarsys from '@/components/SignUpForm/Emarsys';
import { useContainer } from '../context';
import { StageRangeType } from '../context';
import EcoCreditRules from '@/components/EcoCredits/EcoCreditRules';
import { getRewardUserInfo, getRewardEarnRule } from '@/service';
import { useStore } from '../../context';
import { imgList } from '../../AppreciationDay/imgConfig';
import { getPrivacyPolicy } from '@/utils/common';

const EuAppreciationDay = () => {
    const { useLang, useRouter, useState, gtm, Link } = useGlobal();
    const { t } = useLang('ecocredits');
    const { t: t1 } = useLang('appreciationday.activity');
    const router = useRouter();
    const { locale } = router;
    const { stage, isLogin } = useContainer();
    const [open, setOpen] = useState(false);
    const [agree, setAgree] = useState(false);
    const [rewardUserInfo, setRewardUserInfo] = useState({});
    // const [rewardEarnRule, setRewardEarnRule] = useState([]);
    // const [showPage, setShowPage] = useState('basic');
    const state = useStore();

    const img = imgList[locale] || imgList.eu;

    const successCallBack = () => {
        setOpen(true);
        try {
            gtm.push({
                event: 'uaEvent',
                event_name: 'activity_submit',
                button_name: t('appreciationday_btn3'),
                status: 'success',
            });
        } catch (e) {
            console.error(e);
        }
    };

    const errorCallback = () => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'activity_submit',
            button_name: t('appreciationday_btn3'),
            status: 'fail',
        });
    };
    const emailConf = {
        type: 'emarsys',
        source: 'ECO_CREDITS_DAY',
    };

    /**
     * 查询账户积分详情
     */
    const queryRewardUserInfo = async () => {
        const res = await getRewardUserInfo(locale as string);
        if (res?.code === '0') {
            setRewardUserInfo(res.data || {});
            return;
        }
    };

    /**
     * 查询积分赚取规则列表
     */
    // const queryRewardEarnRule = async () => {
    //     const res = await getRewardEarnRule(locale as string);
    //     if (res?.code === '0') {
    //         setRewardEarnRule(res.data || []);
    //     }
    // };

    /**
     * 刷新数据
     */
    const refershData = () => {
        if (!isLogin) return;
        // queryRewardEarnRule();
        queryRewardUserInfo();
    };

    /**
     * 数据请求总和
     */
    const initData = () => {
        if (!isLogin) return;
        // queryRewardEarnRule();
        queryRewardUserInfo();
    };

    const createdEmail = () => {
        return (
            <>
                <Emarsys
                    source={emailConf?.source}
                    disabled={euLocaleList.includes(locale) && !agree}
                    submitText={t('appreciationday_btn3')}
                    placeholder={t('appreciationday_tips')}
                    successCallback={successCallBack}
                    errorCallback={errorCallback}
                />
                <Checkbox onChange={(e: CheckboxChangeEvent) => setAgree(e.target.checked)} checked={agree}>
                    <p className="protocol">
                        {t.rich('appreciationday_protocol', {
                            line2: (text: string) => (
                                <Link className="link" href={`https://${locale}.ecoflow.com/policies/terms-of-service`} target="_blank" rel="noreferrer">
                                    {text}
                                </Link>
                            ),
                            line1: (text: string) => (
                                <Link className="link" href={getPrivacyPolicy(locale)} target="_blank" rel="noreferrer">
                                    {text}
                                </Link>
                            ),
                        })}
                    </p>
                </Checkbox>
            </>
        );
    };

    const createdText = useMemo(() => {
        let text = '';
        const canExchanged = state.FREE_PRODUCTS_RULES_URL.length !== 0 && state.FREE_PRODUCTS_RULES_URL.some((item) => item.stock > 0);

        if (stage === StageRangeType.stage1) {
            text = canExchanged ? t1('title_current1') : t1('title_after1');
        }

        if (stage === StageRangeType.stage2) {
            text = canExchanged ? t1('title_current2') : t1('title_after2');
        }

        return (
            <>
                <div className="title_eu">{text}</div>
                <div className="email-box">{createdEmail()}</div>
            </>
        );
    }, [stage, state, agree]);

    useThrottleEffect(() => {
        initData();
    }, []);

    return (
        <div className={css.appreciation_day} id="APPRECIATION_DAY">
            <div className="title">{t1('title')}</div>
            <div className="desc">{t1('desc')}</div>

            <div className={`banner eu_banner`}>
                <EditorImg pc={img.pc} h5={img.h5} alt={t('appreciationday_title')} aria-label={t('appreciationday_title')} />
                <div className="text_box">{createdText}</div>
            </div>

            <EcoCreditRules
                title=""
                subtitle=""
                className="ecocredit_rule_wrapper"
                pathUrl={`/${locale}/ecocredits`}
                defauleActiveTab={'FREE_PRODUCTS_RULES_URL'}
                isLogin={isLogin}
                refershData={refershData}
                rewardUserInfo={rewardUserInfo}
                setShowPage={() => {}}
            />

            {/* 订阅弹窗 */}
            <EfModal
                className={`${styledModal.subscribe_modal}`}
                open={open}
                visible={open}
                width={812}
                onCancel={() => {
                    setOpen(false);
                }}
                zIndex={999}
            >
                <div className="content">
                    <h6>{t('appreciationday_success_title')}</h6>
                    <p>{t('appreciationday_success_desc')}</p>
                </div>
            </EfModal>
        </div>
    );
};

export default EuAppreciationDay;
